"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _carSelectorGrid = require("@mmc/car-selector-grid");

var _actionTypes = require("../../redux/actions/action-types");

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    changeEvent: function changeEvent(vehicleCode, modelCode) {
      dispatch({
        type: _actionTypes.VEHICLE_UPDATE_OR_ADD,
        vehicleChosed: {
          vehicleCode: vehicleCode,
          modelCode: modelCode
        }
      });
      dispatch({
        type: _actionTypes.VEHICLE_LIST_SHOW_HIDE,
        flag: {
          stage1: false,
          stage2: true,
          overlayDialog: false
        }
      });
    }
  };
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    data: {
      productTile: [].concat(ownProps.vehicles),
      selectedLabel: ownProps.vehicles[0].selectLabel
    },
    selectedModels: state.vehicleCompare.modelSelectedList
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_carSelectorGrid.CarSelectorGrid);

exports["default"] = _default;